import {Modal} from '@/components/ui/modal/Modal'
import styled, {css} from 'styled-components'

export const StyledVerifyAgeModal = styled(Modal)`
    ${({theme: {spacing}}) => css`
        & div:first-child {
            padding: ${spacing * 2}px ${spacing * 2}px 0;
        }
    `}
`
export const StyledVerifyAgeModalContent = styled.div`
    ${({theme: {mediaQueries, spacing, typography}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing}px;
        text-align: center;
        padding: 0 ${spacing * 2}px ${spacing * 2}px;
        & h1 {
            ${typography.textXXl}
            line-height: normal;
        }
        & p {
            ${typography.textSm}
        }
        & button {
            margin-top: ${spacing * 2}px;
            max-height: 24px;
            display: flex;
            justify-content: center;
        }
        ${mediaQueries.m} {
            & h1 {
                ${typography.text2Xl}
                line-height: normal;
            }
            & p {
                ${typography.textMd}
            }
        }
    `}
`
